
export default function BlackList({ arrBlackList }: { arrBlackList: any[] }) {

    return (
        <div className="space-y-4">
            <p>Sono già presenti una o più anagrafiche con dati uguali/simili a quella che stai creando:</p>
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="overflow-y-scroll h-[250px]">
                        <table className="min-w-full">
                            <thead className="border-b bg-white">
                                <tr>
                                    <th scope="col" className="text-sm font-medium text-gray-900 px-6 py-2">Codice ospite</th>
                                    <th scope="col" className="text-sm font-medium text-gray-900 px-6 py-2">Blacklist</th>
                                </tr>
                            </thead>
                            <tbody>

                                {arrBlackList?.map((el) => (
                                    <tr key={`trList-${el.codiceOspite}`} className={`${el.inBlacklist ? 'bg-red-200 border-b-red-500' : 'bg-white'} border-b !rounded-none`}>
                                        <td className="text-sm text-gray-900 font-light px-6 py-2 whitespace-nowrap !rounded-none">{el?.codiceOspite}</td>
                                        <td className="text-sm text-gray-900 font-light px-6 py-2 whitespace-nowrap !rounded-none">{el.inBlacklist ? 'Si' : 'No'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <p>
                <span className="font-bold">Procedere </span>
                con il salvataggio?
            </p>
        </div>
    )
}